module.exports = __webpack_public_path__ + "static/dotted-85ba5f441efbfd81825b31eaef819cdb.png";